var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasModalContent),expression:"hasModalContent"}],staticClass:"modal-page"},[(_vm.hasModalContent)?_c('portal-target',{staticClass:"h-100",attrs:{"name":"modal-page"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }